module.exports = __webpack_public_path__ + "img/typescript.c8b12662.svg";